interface IState {
  isOpen: boolean;
}

const initState = {
  isOpen: true,
};

interface IAction {
  type: 'TOGGLE_SIDEBAR';
  payload: any;
}

export default function dashboardReducer(state: IState = initState, action: IAction): IState {
  if (action.type === 'TOGGLE_SIDEBAR') {
    return { ...state, isOpen: !state.isOpen };
  }

  if (action.type === 'CLOSE_SIDEBAR') {
    return { ...state, isOpen: false };
  }

  return state;
}
